import { useMemo } from 'react';
import { ConfigType } from '@scale/shared/defaults';
import { IProjectJson } from '@scale/shared/types/project';
import { IConfigMeta } from 'corp/components/JsonSchemaConfigs/configTransforms';
import { ConfigAttributes } from '@scale/shared/types/configAttribute';
import { IUserJson } from '@scale/shared/types/user';

const getConfigAttributes = (
  configMeta: IConfigMeta | undefined,
  project: IProjectJson | null | undefined,
  user: IUserJson,
  experimentId: string | undefined,
): ConfigAttributes | null => {
  // todo(andrea.jaba): handle business unit configs in the future
  if (
    !configMeta ||
    (configMeta.type === ConfigType.Project && !project) ||
    configMeta.type === ConfigType.BusinessUnit
  ) {
    return null;
  }

  switch (configMeta.type) {
    case ConfigType.Project:
      return {
        project: configMeta.id!,
        taskCustomer: project!.taskCustomer,
        ...(project!.taskType ? { taskType: project!.taskType } : {}),
        businessUnit: project!.businessUnit,
      };
    case ConfigType.TaskCustomerType:
      return {
        taskCustomer: user.id!,
        ...(configMeta.taskType ? { taskType: configMeta.taskType } : {}),
      };
    case ConfigType.TaskCustomer:
      return {
        taskCustomer: user.id!,
      };
    case ConfigType.TaskType:
      return configMeta.taskType ? { taskType: configMeta.taskType } : {};
    case ConfigType.Experiment:
      return {
        experimentId,
        project: configMeta.id!,
        taskCustomer: project?.taskCustomer,
        ...(project?.taskType ? { taskType: project?.taskType } : {}),
      };
    case ConfigType.Default:
      return {};
  }
};

export const useConfigAttributes = (
  configMeta: IConfigMeta | undefined,
  project: IProjectJson | null | undefined,
  user: IUserJson,
  experimentId?: string,
): ConfigAttributes | null => {
  return useMemo(
    () => getConfigAttributes(configMeta, project, user, experimentId),
    [configMeta, experimentId, user, project],
  );
};
